import { z } from "zod";

export const update = z.object({
  id: z.number(),
  allowedOrgs: z.number().array().prefault([]),
});

export const updateOverride = z.object({
  id: z.number(),
  defaultRole: z.string().nullish(),
  allowedOrgs: z.number().array().prefault([]),
  role: z.string().nullish(),
  orgId: z.number().nullish(),
});

export const activate = z.object({
  id: z.number(),
});

export const deactivate = z.object({
  id: z.number(),
});
